import { extend, localize ,configure} from "vee-validate";
import { min, required, email ,between, min_value,max_value, numeric,alpha , alpha_spaces, max,confirmed,image,dimensions,regex} from "vee-validate/dist/rules";
import en from "vee-validate/dist/locale/en.json";

// Install rules
extend("required", required);
extend("min", min);
extend("email", email);
extend("between", between);
extend("min_value", min_value);
extend("max_value", max_value);
extend("numeric", numeric);
extend("alpha", alpha);
extend("alpha_spaces", alpha_spaces);
extend("max", max);
extend("confirmed", confirmed);
extend("image", image);
extend("dimensions", dimensions);
extend("regex", regex);

extend('no_double_spaces', {
  validate: (value) => !/\s{2,}/.test(value),
  message: 'The field cannot contain consecutive spaces.',
});

// Install classes
configure({
  classes: {
    invalid: 'is-invalid'
  }
})

// Install messages
localize({
  en
});